<template>
  <div>
    <div>
      <div style="display: grid; grid-template-columns: repeat(4, 1fr); gap: 10px;">
          <vs-button 
            type="gradient" 
            class="mb-2" 
            @click="title='Devolución Códigos'; menu = 0;" 
            :style="menu === 0 ? {backgroundColor: '#000'} : {backgroundColor: '#85c1e9'}">
              <i class="fa-solid fa-right-left"></i> Devolución Códigos
          </vs-button>
          <vs-button 
            type="gradient" 
            class="mb-2" 
            @click="title='Devolver Códigos por documentos'; menu = 1;" 
            :style="menu === 1 ? {backgroundColor: '#000'} : {backgroundColor: '#85c1e9'}">
              <i class="fa-solid fa-square-check"></i> Devolver Códigos por documentos
          </vs-button>
      </div>
      <br>
      <vx-card :title="title">
        <!--components-->
        <!--Devolución Códigos-->
        <div v-if="menu == 0"><devolucionBodegaVue/></div>
        <!--Devolver Códigos por documentos-->
        <div v-if="menu == 1"><ImportLimpiarDataVue/></div>
      </vx-card>
    </div>
  </div>
</template>

<script>
const devolucionBodegaVue         = () => import('../../devolucionBodega.vue')
const ImportLimpiarDataVue        = () => import('../../../codigos/components/ImportLimpiarData.vue');
export default {
  components: {
    devolucionBodegaVue,
    ImportLimpiarDataVue
  },
  data() {
    return{
      menu: 0,
      title: 'Devolución Códigos'
    }
  },
}
</script>
